'use strict';
// B.2.3.6 String.prototype.fixed()
require('./_string-html')('fixed', function(createHTML){
  return function fixed(){
    return createHTML(this, 'tt', '', '');
  }
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/core-js/2.4.0/core-js/modules/es6.string.fixed.js
 ** module id = 430
 ** module chunks = 0
 **/